import { cx } from "@suse-o11y/class-variance";
import React from "react";

import type { MonitorCheckStatusRelatedFailuresCheckStatus } from "../../../../common/openapi";
import { HealthStateCircle } from "../../../../components/react/HealthCircle/HealthStateCircle";
import { ViewTimeLink } from "../../../../components/react/viewtimelink/ViewTimeLink";

interface RelatedHealthViolationProps {
	item: MonitorCheckStatusRelatedFailuresCheckStatus;
	/**
	 * @default true
	 */
	showTriggeredTimestamp?: boolean;
	title: React.ReactNode;
	className?: string;
}

export const RelatedHealthViolation: React.FC<React.PropsWithChildren<RelatedHealthViolationProps>> = ({
	item,
	showTriggeredTimestamp = true,
	children,
	title,
	className,
}) => (
	<div className={cx("text-13/[21px]", className)} data-testid="related-health-violation">
		<div className="mb-px flex items-center gap-3">
			<HealthStateCircle size="small" state={item.health} />

			{title}
		</div>
		<div className="flex gap-1 text-grey-600">
			<div className={cx("flex gap-1", showTriggeredTimestamp ? "max-w-[calc(100%-140px)]" : "w-full")}>{children}</div>
			{showTriggeredTimestamp && <ViewTimeLink className="whitespace-nowrap" time={item.triggeredTimestamp} />}
		</div>
	</div>
);
